import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { getData } from '../../../api/indexedDBHandler'
import WeighingTournamentProtocolPDF from './WeighingTournamentProtocolPDF'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'

// Выносим логику генерации протокола в отдельную функцию
const generateProtocolData = async (id) => {
  const getname = (teamData, t) => {
    if (t.competition_type == 'Рейтинговое соревнование') {
      return teamData?.team_name_ru
    }
    console.log('vvvvvv ', teamData.preferred_name, teamData?.team_name_en, t)
    return teamData?.preferred_name === 'en'
      ? teamData?.team_name_en || teamData?.team_name_ru
      : teamData?.team_name_ru
  }

  const resultsT = await getData('tournaments', 'id', id)
  if (resultsT.length === 0) throw new Error('No tournament data found')
  const { value: tournamentValue } = resultsT[0]
  const isFinish = tournamentValue.status_cup === 'Турнир завершен'
  const allLogos = Object.values(tournamentValue.sponsor || {})
  const administrator = Object.values(tournamentValue.administrator || [])

  const resultsU = await getData('teams', 'id', id)
  if (resultsU.length === 0) throw new Error('No team data found')
  const { value: teamValue } = resultsU[0]
  const filteredTeams = Object.values(teamValue).filter(
    (teamEntry) =>
      teamEntry !== null &&
      typeof teamEntry === 'object' &&
      teamEntry.team?.status === 'Заявка одобрена' &&
      teamEntry.team?.status_location === 1
  )
  // Создаем объект с информацией о командах
  const teams = {}
  filteredTeams.forEach((team) => {
    const sp1sports_category = team.athlete[0]?.sports_category
      ? ' (' + team.athlete[0]?.sports_category + ')'
      : ''
    const sp1 = team.athlete[0]?.fio ? team.athlete[0]?.fio : ''

    const sp2sports_category = team.athlete[1]?.sports_category
      ? ' (' + team.athlete[1]?.sports_category + ')'
      : ''
    const sp2 = team.athlete[1]?.fio ? ', ' + team.athlete[1]?.fio : ''

    const sp3sports_category = team.athlete[2]?.sports_category
      ? ' (' + team.athlete[2]?.sports_category + ')'
      : ''
    const sp3 = team.athlete[2]?.fio ? ', ' + team.athlete[2]?.fio : ''

    const name = getname(team.team, tournamentValue)

    teams[team.team.id] = {
      team: name,
      sector: team.team.sector,
      sp:
        sp1 +
        sp1sports_category +
        sp2 +
        sp2sports_category +
        sp3 +
        sp3sports_category,
    }
  })

  const resultsS = await getData('stage', 'id', id)
  if (resultsS.length === 0) throw new Error('No stage data found')
  const { value: stageValue } = resultsS[0]
  const filteredStageArrays = Object.values(stageValue).filter(
    (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
  )
  //console.log('stageArray', filteredStageArrays)
  const data = filteredStageArrays
  const lastWeighing = Math.max(...data[0].map((entry) => entry.weighing))

  // Фильтруем данные по последнему взвешиванию
  const lastWeighingData = data[0].filter(
    (entry) => entry.weighing === lastWeighing
  )
  // console.log('lastWeighingData', lastWeighingData)
  // Создаем объект для хранения протокола
  const weighingProtocol = {}

  // Обрабатываем каждую запись последнего взвешивания
  lastWeighingData.forEach((entry) => {
    if (!entry.teamId) return
    if (entry.fishList && entry.fishList[0]?.weight === 0) return

    // Создаем запись для команды, если её еще нет
    if (!weighingProtocol[entry.teamId]) {
      weighingProtocol[entry.teamId] = {
        teamName: entry.teamName
          ? entry.teamName
          : teams[entry.teamId]?.team || '',
        sp: teams[entry.teamId]?.sp || '',
        sector: teams[entry.teamId]?.sector || '',
        totalWeight: 0,
        fishCount: 0,
        biggestFish: 0,
        fishList: [],
        weighingNumber: lastWeighing,
      }
    }

    // Если есть рыба - добавляем в протокол
    if (entry.fishList && entry.fishList.length > 0) {
      const weight = entry.fishList.reduce((sum, fish) => sum + fish.weight, 0)
      const biggestFish = Math.max(...entry.fishList.map((fish) => fish.weight))

      weighingProtocol[entry.teamId].totalWeight += weight
      weighingProtocol[entry.teamId].fishCount += entry.fishList.length
      weighingProtocol[entry.teamId].biggestFish = Math.max(
        weighingProtocol[entry.teamId].biggestFish,
        biggestFish
      )

      // Добавляем каждую рыбу с деталями
      entry.fishList.forEach((fish) => {
        const fishtype = fish.type === 'карп' ? '(к)' : '(а)'
        const fishEntry = fish.weight + '' + fishtype
        weighingProtocol[entry.teamId].fishList.push(fishEntry)
      })
    }
  })
  //console.log('weighingProtocol', weighingProtocol)
  // Сортируем команды по общему весу
  const sortedProtocol = Object.values(weighingProtocol).sort(
    (a, b) =>
      b.totalWeight - a.totalWeight ||
      b.fishCount - a.fishCount ||
      b.biggestFish - a.biggestFish
  )
  //console.log('sortedProtocol', sortedProtocol)
  // Остальная логика обработки данных...
  // (добавьте вашу логику обработки данных здесь)
  return {
    allLogos,
    mainLogo: getLogoUrl(tournamentValue?.logocup),
    data: sortedProtocol,
    administrator,
    tournament: tournamentValue,
    date: dateNowProtocol(new Date()),

    isFinish: isFinish,
    // isFinish,
    // processedData: [], // Замените на ваши обработанные данные
    // totalFishCount: 0, // Замените на реальные значения
    // totalWeight: 0,
    // averageFishWeight: 0,
    // biggestFish: { weight: 0, pair: '' },
  }
}

const DocProtocolWeighing = ({ isProtocolSvodCallback }) => {}
export default {
  generate: async function (id) {
    try {
      const protocolData = await generateProtocolData(id)
      //   console.log('protocolData', protocolData)
      const pdfDoc = (
        <WeighingTournamentProtocolPDF
          allLogo={protocolData.allLogos}
          mainLogo={getLogoUrl(protocolData.tournament?.logocup)}
          data={protocolData.data}
          administrator={protocolData.administrator}
          tournament={protocolData.tournament}
          date={dateNowProtocol(new Date())}
          totalFishCount={protocolData.totalFishCount}
          totalWeight={protocolData.totalWeight}
          averageFishWeight={protocolData.averageFishWeight}
          biggestFish={protocolData.biggestFish}
          isfinish={protocolData.isFinish}
        />
      )

      const blob = await pdf(pdfDoc).toBlob()
      const url = URL.createObjectURL(blob)

      //   const a = document.createElement('a')
      //   a.href = url
      //   a.download = `парный_протокол_${dateNowProtocol(new Date())}.pdf`
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      const servaurl = await uploadPdfToServer(blob, id)
      return {
        blob,
        previewUrl: servaurl,
        data: protocolData,
      }
    } catch (error) {
      console.error('Ошибка при генерации протокола:', error)
      throw error
    }
  },
}
const uploadPdfToServer = async (blob, id) => {
  try {
    const formData = new FormData()
    formData.append(
      'pdf',
      blob,
      `протокол_взвешивания_${dateNowProtocol(new Date())}.pdf`
    )
    formData.append('id', id)
    formData.append('isPost', 3)

    formData.append('type', 'ProtocolWeighing')
    const response = await fetch(
      'https://www.admin-protocarp.ru/php/uploads/upload.php',
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.ok) {
      const result = await response.json()
      // Обновляем URL на серверный, если нужно
      return { fileUrl: result.fileUrl }
    } else {
      console.error('Ошибка загрузки файла на сервер')
      return { fileUrl: null }
    }
  } catch (error) {
    console.error('Ошибка при загрузке на сервер:', error)
    return { fileUrl: null }
  }
}
